import React, { useEffect, useMemo, useRef } from 'react';
import loop from './loop';

export interface Props {
  className?: string;
  size?: string | number;
  strokeWidth?: number;
}

function useRotate(duration: number) {
  const ref = useRef<SVGElement>();
  useEffect(() => {
    const element = ref.current as SVGElement;
    return loop({
      duration,
      update(n: number) {
        element.setAttribute('transform', `rotate(${n * 360})`);
      },
    });
  }, [duration]);
  return ref;
}

export function Spinner(props: Props) {
  const { className, size = '4rem', strokeWidth = 8 } = props;
  const strokeColor = 'rgba(92, 112, 128, 0.4)';
  const duration = 550;
  const radius = useMemo(() => 50 - strokeWidth / 2, [strokeWidth]);
  const length = !Number.isNaN(Number(size)) ? `${size}px` : size;
  const pathRef = useRotate(duration);
  return (
    <div className={`preloader-icon ${className}`} style={{ width: length }}>
      <div
        className="preloader-icon__inner"
        style={{
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          backfaceVisibility: 'hidden',
          lineHeight: 0,
        }}
      >
        <em
          className="preloader-icon__title"
          style={{
            position: 'absolute',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            border: '0',
          }}
        >
          Loading...
        </em>
        <div className="preloader-icon__oval">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="-50 -50 100 100">
            <g fill="none" strokeWidth={strokeWidth} stroke={strokeColor}>
              <circle strokeOpacity=".5" r={radius} />
              <path
                // @ts-ignore
                ref={pathRef}
                d={`M0,-${radius} a${radius},${radius} 0 0,1 ${radius},${radius}`}
                strokeWidth={strokeWidth}
                stroke="currentColor"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}
